import { Link } from 'react-router-dom';
import DashboardLayout from '../components/layout/DashboardLayout';
import Button from '../components/primitives/Button';

/** Shown when an /app/* path has no matching child route. */
export default function AppRouteNotFound() {
  return (
    <DashboardLayout narrow>
      <div className="py-16 text-center max-w-md mx-auto">
        <h1 className="text-xl font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>
          Page not found
        </h1>
        <p className="text-sm mb-6" style={{ color: 'var(--text-muted)' }}>
          That route is not available in the app. Check the URL or return to the dashboard.
        </p>
        <Link to="/app/dashboard" className="app-btn-pill app-btn-pill--primary no-underline">
          Go to dashboard
        </Link>
      </div>
    </DashboardLayout>
  );
}

export function AppSessionGateFallback({ message, onRetry }) {
  return (
    <div
      className="min-h-screen flex items-center justify-center px-6"
      style={{ background: 'var(--bg-dashboard)', color: 'var(--text-muted)' }}
    >
      <div className="max-w-md text-center">
        <p className="text-sm mb-4">{message}</p>
        {onRetry && (
          <Button variant="secondary" onClick={onRetry}>
            Try again
          </Button>
        )}
      </div>
    </div>
  );
}
